<!--
 * @Author: DQL
 * @Date: 2021-12-30 14:49:24
 * @LastEditors: DQL
 * @LastEditTime: 2022-02-28 18:11:35
 * @Description: 选择办理人组件（单选）——下一环节审批人选择（单选）
-->
<template>
  <el-dialog
    v-loading="isLoading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50"
    title="选择办理人"
    :visible.sync="show"
    :modal="false"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <section>
      <el-form
        ref="filterParams"
        class="c-form"
        :model="filterParams"
        :inline="true"
        label-position="right"
        label-width="100px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="组织机构"
              prop="deptCode"
            >
              <hm-tree-select
                v-model="filterParams.deptCode"
                class="c-tree-select-wrap"
                instance-id="cTreeSelect"
                placeholder="请选择组织机构"
                loading-text="加载中..."
                :append-to-body="true"
                :clearable="false"
                :multiple="false"
                :options="deptList"
                :normalizer="normalizer"
                @input="handleChangeDept"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="岗位"
              prop="roleCode"
            >
              <el-select
                v-model="filterParams.roleCode"
                class="c-form__select"
                placeholder="请选择岗位"
                @change="handleGwChange"
              >
                <el-option
                  v-for="item in gwList"
                  :key="item.gwDm"
                  :label="item.gwmc"
                  :value="item.gwDm"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      v-loading="loadingUser"
      class="c-flex-transfer u-mg-t-10"
    >
      <el-table
        ref="sourceTable"
        class="o-header-text-center"
        height="calc(400px)"
        stripe
        border
        :data="sourceData"
        @row-click="handleRowClick"
      >
        <el-table-column
          width="30"
          class-name="c-table-column--selection"
        >
          <template
            slot-scope="scope"
          >
            <el-radio
              v-model="selectUserCode"
              :label="scope.row.userid"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="username"
          label="待选列表"
        />
      </el-table>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        :disabled="selectUserCode<=0"
        @click="handleSave()"
      >
        保存
      </el-button>
      <el-button
        @click="handleClose()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { selectUserService, completeSelect } from './blrSelect.service';

export default {
  name: 'SingleBlrSelect',
  // 接口
  props: {
    // 机构范围
    deptFw: {
      validator: val => typeof val === 'string' || val === null,
      default: null
    },
    // 流程实例ID
    processInsId: {
      validator: val => typeof val === 'string' || val === null,
      default: null,
      required: true
    },
    // 任务ID
    taskId: {
      validator: val => typeof val === 'string' || val === null,
      default: null,
      required: true
    },
    // 审批结论
    condition: {
      type: [String, Number],
      default: function () {
        return null;
      }
    },
    // 是否回调
    isCallBack: {
      type: Boolean,
      default: true
    },
    // 加载状态
    isLoading: {
      type: Boolean
    },
    // 是否提交显示选人弹框
    isSubmit: {
      type: Boolean
    }
  },
  data () {
    return {
      show: false,
      loadingUser: false, // 弹窗loading状态
      selectDisabled: false,

      /* 查询条件（页面绑定的查询条件） Start */
      filterParams: {
        deptCode: null,
        roleCode: null
      },
      /*  查询条件 End */

      deptList: [], // 组织机构下拉树
      gwList: [], // 岗位下拉框
      sourceData: [], // 待选列表数据
      selectUserCode: null, // 已选列表用户数据
      isSave: false // 保存标志
    };
  },
  computed: {
    /**
     * @description: 判断是否显示选人页面弹窗
     * @param {*}
     * @return {*}
     */
    isShow () {
      return this.isSubmit;
    }
  },
  methods: {
    /**
     * @description: 关闭弹窗
     * @param {*}
     * @return {*}
     */
    handleClose () {
      this.show = false;
      if (this.isCallBack && this.isSave) {
        this.$emit('update:isLoading', true);
      }
      this.$emit('update:isSubmit', false);
    },
    /**
     * @description: 转换下拉树节点字段
     * @param {*}
     * @return {*}
     */
    normalizer (node) {
      return {
        id: node.deptCode,
        label: node.deptname,
        children:
          node.children && node.children.length > 0 ? node.children : undefined
      };
    },
    /**
     * @description: 获取组织机构数据
     * @param {*}
     * @return {*}
     */
    handleGetDeptTree () {
      this.$emit('update:isLoading', true);
      selectUserService.getDeptTree(this.processInsId, this.taskId, { deptFw: this.deptFw, condition: this.condition })
        .then(rsp => {
          // 若无机构数据返回，直接保存
          if (rsp.data.length === 0) {
            this.handleSave();
          } else {
            this.deptList = rsp.data;
            this.show = true;
            // 若只有一个机构，默认选择并加载岗位
            if (rsp.data.length === 1) {
              this.filterParams.deptCode = rsp.data[0].deptCode;
              this.handleGetGwList();
            } else {
              this.$emit('update:isLoading', false);
            }
          }
        })
        .catch(() => {
          this.$emit('update:isLoading', false);
          this.$emit('update:isSubmit', false);
        });
    },
    /**
     * @description: 获取岗位数据
     * @param {*}
     * @return {*}
     */
    handleGetGwList () {
      this.selectDisabled = true;
      selectUserService.getGwList(this.processInsId, this.taskId, { condition: this.condition, bmDm: this.filterParams.deptCode })
        .then(rsp => {
          this.gwList = rsp.data;
          // 若只有一个岗位，默认选择并加载办理人员
          if (rsp.data.length === 1) {
            // this.filterParams.roleCode = rsp.data[0].roleCode;
            this.filterParams.roleCode = rsp.data[0].gwDm;
            this.handleGetUserList();
          } else {
            this.$emit('update:isLoading', false);
          }
        })
        .catch(() => {
          this.selectDisabled = false;
          this.$emit('update:isLoading', false);
          this.$emit('update:isSubmit', false);
        });
    },
    /**
     * @description: 获取办理人员数据
     * @param {*}
     * @return {*}
     */
    handleGetUserList () {
      selectUserService.getUserList(this.processInsId, this.taskId, { bmDm: this.filterParams.deptCode, gwDm: this.filterParams.roleCode })
        .then(rsp => {
          this.sourceData = rsp.data;
          this.selectDisabled = false;
          // 若只有一个办理人，默认选择并直接保存（前面已保证只有一个机构、一个岗位）
          if (this.deptList.length === 1 && this.gwList.length === 1 && rsp.data.length === 1) {
            this.selectUserCode = rsp.data[0].userid;
            // this.handleSave();
            // this.$emit('update:isSubmit', false);
          }
          this.$emit('update:isLoading', false);
        })
        .catch(() => {
          this.selectDisabled = false;
          this.$emit('update:isLoading', false);
          this.$emit('update:isSubmit', false);
        });
    },
    /**
     * @description: 组织机构修改事件
     * @param {*}
     * @return {*}
     */
    handleChangeDept () {
      // this.loadingUser = true;
      this.handleGetGwList();
    },
    /**
     * @description: 岗位修改事件
     * @param {*}
     * @return {*}
     */
    handleGwChange () {
      // this.loadingUser = true;
      this.handleGetUserList();
    },
    /**
     * @description: 可选数据点击行勾选
     * @param {*}
     * @return {*}
     */
    handleRowClick (row, column, event) {
      this.selectUserCode = row.userid;
    },
    /**
     * @description: 保存按钮点击事件
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.isSave = true;
      if (this.isCallBack) {
        // 将人员数据返回给调用页面，由调用页面的@submitCallback回调方法实现
        this.$emit('submitCallback', this.selectUserCode);
        this.handleClose();
      } else {
        // 直接提交完成该工作项
        this.handleSubmit();
      }
    },
    /**
     * @description: 根据办理人数据提交该工作项
     * @param {*}
     * @return {*}
     */
    handleSubmit () {
      if (!this.selectUserCode) {
        this.$alert('请选择办理人', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        });
        return;
      }
      // 提交工作项
      completeSelect(this.processInsId, this.taskId, { condition: this.condition, users: [this.selectUserCode] })
        .then(rsp => {
          this.handleClose();
          this.$emit('completeCallback');
          this.$alert(rsp.data.data, '提示', {
            confirmButtonText: '确定',
            callback: action => {
            }
          });
        })
        .catch(() => {
        });
    }
  },
  watch: {
    isShow (newVal, oldVal) {
      if (newVal) {
        this.handleGetDeptTree();
      }
    }
  },
  mounted () {
    // this.handleGetDeptTree();
  }
};
</script>
